import React, { useContext, useState } from "react";
import {
  Box,
  Button,
  IconButton,
  Tooltip,
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { DataGrid } from "@mui/x-data-grid";
import { DataContext } from "./index";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import ComponentBackdrop from "../../components/backdrop";
import CustomTheme from "../../theme/customTheme";
import toast from "react-hot-toast";
import { Edit, Visibility } from "@mui/icons-material";
import CustomToolbar from "../../utils/customToolbar";

export default function Listing({ handleShowButton }) {

  const rows = useContext(DataContext);
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  const navigate = useNavigate();

  const onSelectedCheckbox = (id, rows) => {
    let selectedIds = [];

    if (id.type === 'include') {
      selectedIds = Array.from(id.ids);
    }
    else if (id.type === 'exclude') {
      const excluded = new Set(id.ids);
      selectedIds = rows.filter(row => !excluded.has(row.id)).map(row => row.id);
    }
    console.log("selectCheckBox:", selectedIds);
    handleShowButton(selectedIds);
  }

  const navigateDetails = (id) => {
    navigate(`/view-event/${id}`);
  }

  const columns = [
    {
      field: "Actions",
      headerName: "Action",
      width: 100,
      type: "actions",
      hideable: false,
      getActions: (params) => [
        <IconButton
          sx={{ color: "#39493F" }}
          onClick={() => navigateDetails(params.row.id)} // 👈 navigate with row id
        >
          <Tooltip title="View" placement="right">
            <Visibility />
          </Tooltip>
        </IconButton>,
      ],
    },
    {
      field: "eventId",
      headerName: "#",
      width: 80,
      headerAlign: "left",
      align: "center",
    },
    {
      field: "title",
      headerName: "Event & Announcement Title",
      width: 250,
      // flex: 1,

    },
    {
      field: "description",
      headerName: "Description",
      width: 250,
      // flex: 1,
    },
    {
      field: "eventDate",
      headerName: "Start Date",
      minWidth: 150,
      align: "left",
      valueGetter: (params) => {

        if (params) {
          const formatted = dayjs(params).format('DD-MM-YYYY');
          return formatted;
        }
      },
      renderCell: (params) => {
        return (
          <Box style={{ width: "100%", textAlign: "center" }}>
            {params.value || '-'}
          </Box>
        );
      }
    },
    {
      field: "publishDate",
      headerName: "Published Date",
      minWidth: 150,
      align: "center",
      // flex: 1,
      valueGetter: (params) => {
        if (params) {
          const formatted = dayjs(params).format('DD-MM-YYYY');
          return formatted;
        }
      },
      renderCell: (params) => {
        return (
          <Box style={{ width: "100%", textAlign: "center" }}>
            {params.value || '-'}
          </Box>
        );
      }
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 100,
    },
    {
      field: "eventVenue",
      headerName: "Venue",
      minWidth: 150,
      // flex: 1,
    },
    {
      field: "creatorName",
      headerName: "Created By",
      minWidth: 160,
    },
    {
      field: "createdDate",
      headerName: "Created Date",
      // flex: 1,
      minWidth: 150,
      align: "center",
      valueGetter: (params) => {
        if (params) {
          const formatted = dayjs(params).format('DD-MM-YYYY');
          return formatted;
        }
      },
      renderCell: (params) => {
        return (
          <Box style={{ width: "100%", textAlign: "center" }}>
            {params.value || '-'}
          </Box>
        );
      }
    }
  ];

  return (
    <Box
        style={{
          width: "100%",
          height: "77vh",
          overflowY: rows.length > 10 ? "auto" : "visible", // scroll if too many
        }}
      >
      <ComponentBackdrop open={open} close={handleClose} />
      <DataGrid
        columns={columns}
        rows={rows}
        showToolbar
         slots={{ toolbar: CustomToolbar }}
        pageSizeOptions={[50, 100, { value: 500, label: "500" }]}
        initialState={{
          pagination: {
            paginationModel: { pageSize: 50 },
          },
          sorting: {
            sortModel: [{ field: "eventDate", sort: "desc" }],
          },
          columns: {
              columnVisibilityModel: {
                eventId: false, // hide ID column by default
              },
            },
             filter: {
              filterModel: {
                items: [
                  {
                    field: "status",
                    operator: "doesNotEqual",
                    value: "Cancelled", // ✅ default filter
                  },
                ],
              },
            },
        }}
        slotProps={{
           toolbar: {
            title: ""
           },
          loadingOverlay: {
            variant: "linear-progress",
            noRowsVariant: "skeleton",
          },
          disableToolbarButton: {
            csvOptions: "true",
            printOptions: "true"
          },
          toolbar: {
            printOptions: { disableToolbarButton: true },
            csvOptions: { disableToolbarButton: true }
          },
        }}
        // checkboxSelection
        onRowSelectionModelChange={(id) => {
          onSelectedCheckbox(id, rows);
        }
        }
        disableRowSelectionOnClick
        localeText={{ noRowsLabel: "No records found" }}
      />
      {/* </ThemeProvider> */}
    </Box>
  );
}
